// Replaces placeholders in an alias text with values, for example
// "New color: {newColor}" with { newColor: "white" }.
// Placeholders without a matching key are left untouched, while a key without
// a value is replaced with an empty string.
export const interpolateAlias = (text = "", values = {}) =>
  Object.entries(values).reduce(
    (result, [key, value]) =>
      result
        .split(`{${key}}`)
        .join(value === undefined || value === null ? "" : String(value)),
    text
  );
